const bonusEngine = {
  bonusTypes: {
    BETSOFT_CASINO: 'Betsoft Casino',
    CASINO_STANDARD: 'Casino Standard',
    SPORTS_STANDARD: 'Sports Standard',
    FREE_PLAY: 'Free Plays',
    FREE_SPINS: 'Free Spins',
  },
  bonusAmountTypes: {
    PERCENTAGE: 'Percentage',
    FIXED: 'Fixed',
  },
  bonusTriggerTypes: {
    DEPOSIT_BY_CODE: 'Deposit - By Code',
    DEPOSIT_BY_CLICK: 'Deposit - By Click',
    GAMIFICATION: 'By Gamification',
    MANUAL: 'By Manual',
    DEPOSIT: 'By Deposit',
    BY_BUNDLE: 'By Bundle',
    BY_CODE: 'By Code',
    BY_REGISTRATION: 'By Registration',
  },
  conditionsTypes: {
    EQUAL: 'Equal',
    NOTEQUAL: 'Not Equal',
    SMALLER: 'Smaller',
    GREATER: 'Greater',
    GREATEREQUAL: 'Greater Equal',
    SMALLEREQUAL: 'Smaller Equal',
  },
  paymentMethodsTypes: {
    BTC: 'Bitcoin',
    ETH: 'Ethereum',
    LTC: 'Litecoin',
    USDT: 'Tether',
    USDC: 'USD Coin',
    CREDITCARD: 'Credit Card',
  },
  bonusMode: {
    DEPOSIT_BONUS: 'Sticky',
    FREE_PLAY: 'Free Play',
    NON_STICKY: 'Non Sticky',
  },
  wageringOrderType: {
    ANY_ORDER: 'Any Order',
    RM_FIRST: 'Real Money First',
  },
  rolloverAmountType: {
    GRANTED_BONUS: 'Granted Bonus',
    QUALIFYING: 'Qualifying Share of Deposit',
    GRANTED_BONUS_QUALIFYING: 'Granted Bonus + Qualifying Share of Deposit',
  },
  rolloverAmountCalculationType: {
    lowerAmount: 'Lower Amount',
    riskAmount: 'Risk Amount',
  },
  minResetRealMoneyAmount: 'Min Reset Real Money Amount',
  createBonusEngine: 'Create Bonus',
  listBonusOffers: 'List Bonus Offers',
  generalSettings: 'General Settings',
  triggerSettings: 'Trigger Settings',
  bonusAmountSettings: 'Bonus Amount',
  freeSpinsSettings: 'Free Spins',
  rolloverSettings: 'Rollover Settings',
  rolloverRestrictionsSettings: 'Rollover Restrictions',
  restrictionsSettings: 'Bonus Restrictions',
  eligibility: 'Eligibility',
  dependencies: 'Dependencies',
  bonusPeriod: 'Bonus Period',
  enableSettings: 'Enabled / Disabled',
  settingsBonus: 'Please complete the following settings',
  bonusStepOne:
    'In this step you must add the name, description, bonus code, type of bonus and base currency of the bonus.',
  baseCurrency: 'Currency',
  maxBet: 'Max Bet',
  maxWin: 'Max Win',
  bonusMaxBet: 'Bonus Max Bet',
  bonusMaxWin: 'Bonus Max Win',
  maxBetAndWin: 'Max Bet & Max Win',
  bonusStepSecond: 'Please select the trigger type and complete the settings',
  triggerTypelabel: 'This bonus can be triggered by',
  bonusPeriodLabel: 'Select a recurrence period',
  noPeriod: 'No Period',
  despositPrerequisites: 'Deposit Prerequisites',
  condition: 'Condition',
  depositCount: 'Deposit Count',
  minimumAmount: 'Minimum Amount',
  paymentMethods: 'Payment Methods',
  bonusAmountType: 'Bonus Amount Type',
  bonusByBundle: 'Bonus By Bundle',
  percentage: 'Percentage',
  cap: 'Cap',
  fixed: 'Fixed',
  amountOfFreeSpins: 'Amount of Free Spins',
  bonusStepFreeSpins:
    'Please set how many free spin rounds this bonus grants to the player.',
  freeSpinQuantityDescription:
    'Number of free spin rounds granted, between {{min}} and {{max}}.',
  freeSpinGamesDescription:
    'Select the BGaming games the free spins can be played on, up to {{max}} games',
  freeSpinGamesSelected: '{{count}} of {{max}} games selected',
  selectAllUpTo: 'Select All (first {{max}})',
  bonusStepThird:
    'Please completed the bonus amount settings in order to save your bonus.',
  selectBonusAmountType: 'Select a Bonus Amount Type',
  selectBonusTriggerType: 'Select a Trigger Type',
  selectItem: 'Select Item',
  bonusStepFourth:
    'Please completed the rollover settings in order to save your bonus.',
  recurrence: 'Recurrence',
  rmMinAmount: 'Real Money Min Amount',
  rmMinAmountCurrency: 'Real Money Min Amount By Currency',
  rmMinAmountMessage:
    'This value determines the minimum Real Money Balance needed, before the player can begin using the bonus wallet. Example: if the value is configured as $5, then the player needs to have a RM Balance of less than $5 before the bonus wallet can be used.',
  rolloverCoefficcientType: 'Base Amount for Rollover Requirement',
  rolloverCalculationType: 'Rollover Amount Calculation Type',
  bonusModeLabel: 'Bonus Mode',
  eligibleGame: 'Eligible Game',
  bonusStepCasino:
    'Please select the Eligible Game Providers that may be used with this bonus',
  bonusStepRolloverRestrictions:
    'In this step, you may configure how the rollover should behave for this particular bonus. In other words, which Sports, Wager Types and Line ranges that should count towards the rollover calculation.',
  bonusStepRestrictions:
    'In this step, you may configure where and how the bonus could be used, by applying specific restrictions where the bonus wallet is applicable, a bonus funds max bet and/or a bonus release max win.',
  bonusByBundleMessage:
    'Please select one or more dependent bonuses to link to the current bonus program:',
  bonusPeriodMessage:
    'Please select the recurrence period configuration to activate the current bonus program:',
  bonusStepStatus:
    'Please check the box, if you want to activate the bonus or activate the make up rule.',
  providerCategory: 'Provider Category',
  selectProviderCategory: 'Select Category',
  providers: 'Providers',
  eligibilityPromotionalCodes: 'Promotional Codes',
  creditCardTiers: 'Credit Card Tiers',
  agentById: 'Agent by ID',
  bonusPromoRepeatedError: 'The Promotional Code may not be repeated',
  bonusCreditRepeatedError: 'The Credit Card may not be repeated',
  addPromotionalCode: 'Add Promotional Code',
  addCreditCard: 'Add Credit Card',
  addAgentById: 'Add Agent ID',
  itemRepeated: 'The item "{{field}}" is repeated',
  pressEnterToAdd: 'Press enter to add',
  statusBonus: 'Bonus Status',
  isMakeUpRule: 'Make Up Rule',
  bonusEnginePopoverAlert: 'Are you sure you want to abort this bonus engine?',
  wageringOrder: 'Wagering Order',
  wageringContributionsEdit: 'Wagering Contribution',
  wageringContributionCategory: 'Wagering Contribution Category',
  maxBonusesAllowedDescription: 'Max Count Of Bonuses Allowed Per Player',
  priorityDescription: 'Ranking Weight Of The Bonus, From 0 To 100',
  restrictions: {
    product: 'Products',
    wagerType: 'Wager Types',
    sports: 'Sports',
    enabled: 'Enabled',
    disabled: 'Disabled',
    discard: 'Discard Contribution',
    rules: 'Rules Option',
    definitionRules: 'Restrictions by Type',
    line: 'Line',
    maxLine: 'Max Line',
    minLine: 'Min Line',
  },
  restrictionsItems: {
    SPORTS: 'Sports',
    LIVE_SPORTS: 'Live Sports',
    CASINO: 'Casino',
    LIVE_CASINO: 'Live Casino',
    HORSES: 'Horses',
    ACTION_POINTS: 'Action Points',
    BLOCK: 'Block',
    CARD_BET: 'Card Bet',
    COMPACT_IF_LOSE: 'Compact If Lose',
    COMPACT_IF_LOSE_OR_TIE: 'Compact If Lose Or Tie',
    COMPACT_IF_WIN: 'Compact If Win',
    COMPACT_IF_WIN_OR_TIE: 'Compact If Win Or Tie',
    COMPACT_REVERSE_ACTION: 'Compact Reverse Action',
    COMPACT_REVERSE_WIN: 'Compact Reverse Win',
    COMPACT_ROUND_ROBIN: 'Compact Round Robin',
    IF_LOSE: 'If Lose',
    IF_LOSE_OR_TIE: 'If Lose Or Tie',
    IF_WIN: 'If Win',
    IF_WIN_OR_TIE: 'If Win or Tie',
    KEY_PARLAY: 'Key Parlay',
    PARLAY: 'Parlay',
    PROPS_BUILDER: 'Props Builder',
    PROPS_BUILDER_WIDGET: 'Props Builder Widget',
    PANA_APUESTAS: 'Pana Apuestas',
    RACING_BET: 'Racing Bet',
    REVERSE_ACTION: 'Reverse Action',
    REVERSE_WIN: 'Reverse Win',
    ROUND_ROBIN: 'Round Robin',
    RAPID_BET: 'Rapid Bet',
    STRAIGHT_BET: 'Straight Bet',
    STAR_SPORTS: 'Star Sports',
    ULTRALIVE: 'Ultra Live',
    TEASER: 'Teaser',
    eSPORT_STRAIGHT_BET: 'E-Sports Straight Bet',
    AGL: 'ALLIANZ GAME LOTTERY',
    ANG: 'ANGUILLA LOTTERY',
    CAST: 'SPORT CAST',
    CBB: 'COLLEGE BASKETBALL',
    CFB: 'COLLEGE FOOTBALL',
    CKPT: 'COCKPIT',
    ESOC: 'EUROPEAN SOCCER',
    ESPRT: 'E-SPORTS',
    MLB: 'ML BASEBALL',
    MU: 'MATCHUPS',
    MBDO: 'MOBADOO',
    NBA: 'NBA BASKETBALL',
    NFL: 'NFL FOOTBALL',
    NHL: 'NHL HOCKEY',
    PMAX: 'PEGA MAX',
    PROP: 'PROPOSITIONS',
    RAC: 'RACING',
    RBL: 'LIVE',
    SOC: 'SOCCER',
    TNT: 'TOURNAMENTS',
    'H ADJ': 'HORSES',
  },
  unitTime: {
    days: 'Days',
  },
  bonusPeriodType: {
    dateRange: 'Date Range',
    daily: 'Daily',
    weekday: 'Weekday',
  },
  recurrenceWeekdayType: {
    all: 'All',
    first: 'First',
    second: 'Second',
    third: 'Third',
    fourth: 'Fourth',
    fifth: 'Fifth',
    last: 'Last',
  },
  dayType: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
  wageringCategory: 'Wagering Category',
  freeSpinsExpirationTime: 'Free Spins Expiration Time',
  expirationTimeUnit: 'Expiration Time Unit',
  bonusEngine: {
    eligibilityByCountry: 'Country',
  },
}

export default bonusEngine
